import '@libs/i18n/I18n';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/scss/cartedo/index.scss';
import './instrument';
import MainApp from './startup/MainApp';

import env from '@config/env';
import type { PostHogConfig } from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

const options: Partial<PostHogConfig> = {
  api_host: env.POSTHOG_HOST,
  disable_session_recording: env.DEV,
};

const rootElement = document.getElementById('root');
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <PostHogProvider apiKey={env.POSTHOG_KEY} options={options}>
        <MainApp />
      </PostHogProvider>
    </React.StrictMode>
  );
}
